import type { WhatsAppInboxMessage } from '@zrsystem/contracts';

export type WhatsAppInboxMediaKind = 'image' | 'audio' | 'video' | 'file';

export function resolveWhatsAppInboxMediaKind(
  message: Pick<WhatsAppInboxMessage, 'hasMedia' | 'media'>,
): WhatsAppInboxMediaKind | null {
  if (!message.hasMedia || message.media === null) {
    return null;
  }

  const mimetype = message.media.mimetype.toLowerCase();
  if (mimetype.startsWith('image/')) {
    return 'image';
  }
  if (mimetype.startsWith('audio/')) {
    return 'audio';
  }
  if (mimetype.startsWith('video/')) {
    return 'video';
  }
  return 'file';
}
